<template>
  <!-- 主区域情报 -->
  <el-row style="position: relative">
    <el-col :span="24" :xs="24">
      <el-image :src="heroInfo.img" fit="cover" alt="Car Image"></el-image>
    </el-col>
    <el-col :xs="24" class="hero-txt">
      <h2 class="hero-txt-title">{{ heroInfo.title }}</h2>
      <p class="hero-txt-desc">{{ heroInfo.content }}</p>
    </el-col>
  </el-row>
  <!-- service区域情报 -->
  <el-row>
    <el-col :span="24" :xs="24" class="service-txt-title">
      {{ $t("home-service-name") }}</el-col
    >
  </el-row>
  <el-row>
    <el-col :span="24" :xs="24" class="service-txt-subtitle">
      {{ serviceInfo.title }}</el-col
    >
  </el-row>
  <!-- service内容 -->
  <el-row class="service-row" :gutter="0">
    <!-- 二手车 -->
    <el-col
      :span="12"
      :xs="24"
      class="service-item"
      @click="navigateTo('/usedCarsSales')"
    >
      <div class="service-card">
        <el-image
          :src="serviceInfo.car_img"
          fit="cover"
          class="service-image"
        ></el-image>
        <div class="service-content">
          <h3 class="service-title">{{ serviceInfo.car_title }}</h3>
          <p class="service-description">{{ serviceInfo.car_content }}</p>
        </div>
      </div>
    </el-col>
    <!-- 配件 -->
    <el-col
      :span="12"
      :xs="24"
      class="service-item"
      @click="navigateTo('/autoPartsSales')"
    >
      <div class="service-card">
        <el-image
          :src="serviceInfo.part_img"
          fit="cover"
          class="service-image"
        ></el-image>
        <div class="service-content">
          <h3 class="service-title">{{ serviceInfo.part_title }}</h3>
          <p class="service-description">{{ serviceInfo.part_content }}</p>
        </div>
      </div>
    </el-col>
  </el-row>
  <!-- service跑马灯title -->
  <el-row>
    <el-col :span="24" :xs="24" class="service-txt-title">
      {{ $t("home-service-ProductList") }}</el-col
    >
  </el-row>
  <!-- service跑马灯 -->
  <div class="carousel-container">
    <el-carousel
      :interval="2000"
      type="card"
      height="500px"
      arrow="always"
      class="carousel-pc"
    >
      <el-carousel-item v-for="img in serviceInfo.imgList" :key="img">
        <el-image
          :src="img.url"
          fit="cover"
          class="service-image2"
          @click="gotoInfo(img.id)"
        ></el-image>
      </el-carousel-item>
    </el-carousel>

    <el-carousel
      :interval="2000"
      height="250px"
      class="carousel-mobile"
      autoplay="true"
      arrow="always"
    >
      <el-carousel-item v-for="img in serviceInfo.imgList" :key="img">
        <el-image
          :src="img.url"
          fit="cover"
          class="service-image"
          @click="gotoInfo(img.id)"
        ></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
  <!-- 問い合わせ -->
  <el-row style="padding-top: 40px">
    <el-col :span="24" :xs="24" class="service-txt-title contack-color">
      {{ $t("home-contact-name") }}</el-col
    >
  </el-row>
  <el-row class="contack-color contack-row" justify="center">
    <!-- 左侧：お問い合わせページ -->
    <el-col :span="10" :xs="24" class="contact-box contact-box-r">
      <h3 class="contact-title">{{ $t("home-contact-left-title") }}</h3>
      <el-button
        type="primary"
        class="contact-button"
        @click="navigateTo('/contact')"
        >{{ $t("home-contact-left-btn") }}</el-button
      >
    </el-col>

    <!-- 右侧：サービスに関するお問い合わせ -->
    <el-col :span="10" :xs="24" class="contact-box contact-box-l">
      <h3 class="contact-title">{{ $t("home-contact-rifht-title") }}</h3>
      <p>
        <strong>{{ $t("home-contact-rifht-tel") }}</strong>
        {{ contactInfo.tel }}
      </p>
      <p>
        <strong>{{ $t("home-contact-rifht-fax") }}</strong>
        {{ contactInfo.fax }}
      </p>
      <p class="contact-note">
        {{ $t("home-contact-rifht-time") }} {{ contactInfo.time }}
      </p>
    </el-col>
  </el-row>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { supabase } from "@/supabase.js";
import { ElLoading } from "element-plus";

export default {
  setup() {
    const { locale } = useI18n();
    const router = useRouter();
    // 主区域情报
    const heroInfo = ref({});
    // service域情报
    const serviceInfo = ref({});
    // 获取問い合わせ情报
    const contactInfo = ref({});

    // 获取主区域情报
    const getHeroInfo = async () => {
      const { data, error } = await supabase
        .from("home_info")
        .select(
          "hero_title_ja, hero_content_ja, hero_title_en, hero_content_en, hero_img"
        )
        .eq("id", "home_info")
        .single();
      if (error) {
        console.error("データ取得エラー:", error);
        ElMessage.error("データ取得エラー");
      } else {
        heroInfo.value.img = data.hero_img;
        if (locale.value === "ja") {
          heroInfo.value.title = data.hero_title_ja;
          heroInfo.value.content = data.hero_content_ja;
        } else {
          heroInfo.value.title = data.title_en;
          heroInfo.value.content = data.hero_content_en;
        }
      }
    };

    // 获取service域图片列表
    const getServiceImg = async () => {
      const { data, error } = await supabase
        .from("img_info")
        .select("sub_imgurl,sub_id")
        .eq("kbn", "2");
      if (error) {
        console.error("データ取得エラー:", error);
        ElMessage.error("データ取得エラー");
      } else {
        serviceInfo.value.imgList = data.map((item) => ({
          url: item.sub_imgurl,
          id: item.sub_id,
        }));
      }
    };

    // 获取service域情报
    const getServiceInfo = async () => {
      const { data, error } = await supabase
        .from("home_info")
        .select(
          "service_title_ja, service_title_en, service_car_img, service_part_img, service_car_title_ja, service_car_title_en, service_part_title_ja, service_car_content_ja, service_car_content_en, service_part_content_ja, service_part_content_en"
        )
        .eq("id", "home_info")
        .single();
      if (error) {
        console.error("データ取得エラー:", error);
        ElMessage.error("データ取得エラー");
      } else {
        serviceInfo.value.car_img = data.service_car_img;
        serviceInfo.value.part_img = data.service_part_img;
        if (locale.value === "ja") {
          serviceInfo.value.title = data.service_title_ja;
          serviceInfo.value.car_title = data.service_car_title_ja;
          serviceInfo.value.part_title = data.service_part_title_ja;
          serviceInfo.value.car_content = data.service_car_content_ja;
          serviceInfo.value.part_content = data.service_part_content_ja;
        } else {
          serviceInfo.value.title = data.service_title_en;
          serviceInfo.value.car_title = data.service_car_title_en;
          serviceInfo.value.part_title = data.service_part_title_en;
          serviceInfo.value.car_content = data.service_car_content_en;
          serviceInfo.value.part_content = data.service_part_content_en;
        }
      }
    };

    //
    const getContactInfo = async () => {
      const { data, error } = await supabase
        .from("home_info")
        .select(
          "contact_tel, contact_fax, contact_mail, contact_time_ja, contact_time_en"
        )
        .eq("id", "home_info")
        .single();
      if (error) {
        console.error("データ取得エラー:", error);
        ElMessage.error("データ取得エラー");
      } else {
        // localStorage.setItem("homeContactInfo", JSON.stringify(data));
        contactInfo.value.tel = data.contact_tel;
        contactInfo.value.fax = data.contact_fax;
        contactInfo.value.mail = data.contact_mail;
        if (locale.value === "ja") {
          contactInfo.value.time = data.contact_time_ja;
        } else {
          contactInfo.value.time = data.contact_time_en;
        }
      }
    };

    const gotoInfo = async (val) => {
      const id = val.split("_")[0];
      const type = val.split("_")[1];
      console.log("id，type：" + id + "," + type);
      if (type === "車") {
        localStorage.setItem("management_number", id);
        router.push("/carInfo");
      } else {
        localStorage.setItem("management_number_part", id);
        router.push("/partInfo");
      }
    };

    // 页面跳转
    const navigateTo = (path) => {
      router.push(path);
    };

    onMounted(async () => {
      // 开启 loading 动画
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 1.0)",
      });
      getHeroInfo();
      getServiceInfo();
      getContactInfo();
      getServiceImg();
      loading.close();
    });

    watch(locale, async () => {
      // 开启 loading 动画
      const loading = ElLoading.service({
        lock: true,
        text: "Loading...",
        background: "rgba(0, 0, 0, 1.0)",
      });
      getHeroInfo();
      getServiceInfo();
      getContactInfo();
      getServiceImg();
      loading.close();
    });

    return {
      heroInfo,
      serviceInfo,
      contactInfo,
      navigateTo,
      gotoInfo,
    };
  },
};
</script>

<style scoped>
.el-image {
  display: block;
  overflow: hidden;
  position: relative;
}
.hero-txt {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  background: rgba(34, 34, 34, 0.5);
  color: #ffffff;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  padding: 0 7.5%;
  width: 50%;
}
.hero-txt-title {
  font-size: 40px;
  margin-bottom: 16px;
  line-height: 1.5;
  text-align: left;
}
.hero-txt-desc {
  line-height: 2.2;
  margin-bottom: 31.6px;
  font-size: 14px;
  text-align: left;
}
.service-txt-title {
  text-align: center;
  font-size: 50px;
  padding: 30px;
  padding-top: 80px;
}
.service-txt-subtitle {
  text-align: left;
  font-size: 30px;
  padding: 0px 100px 30px 100px;
}

.service-row {
  margin-bottom: 20px;
  padding: 0 120px;
}

.service-item {
  display: flex;
  justify-content: center;
}

.service-card {
  position: relative;
  overflow: hidden;
  border-radius: 0px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-image {
  width: 100%;
  height: 400px;
  transition: transform 0.3s ease;
}
.service-image2 {
  width: 100%;
  height: 500px;
  transition: transform 0.3s ease;
  border-radius: 8px;
}

.service-card:hover .service-image {
  transform: scale(1.1);
}

.service-content {
  padding: 0px 20px;
  text-align: center;
}

.service-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: left;
}

.service-description {
  font-size: 14px;
  color: #666;
  text-align: left;
}
.carousel-container {
  padding: 0 80px; /* 左右添加20px余白 */
}

.carousel-pc {
  display: block;
  border-radius: 10px; /* 可选：为轮播图添加圆角 */
  overflow: hidden; /* 确保图片不超出边界 */
}
.carousel-mobile {
  display: none;
}

.contack-row {
  padding-bottom: 40px;
}

.contack-color {
  background: #08455d !important;
  color: white !important;
}

.contact-box-r {
  margin-right: 20px !important;
}
.contact-box-l {
  margin-left: 20px !important;
}

.contact-box {
  padding: 40px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  /* background-color: #1a5276; */
  color: white;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.contact-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 40px;
}

.contact-button {
  background-color: white;
  color: #1a5276;
  font-weight: bold;
  border-radius: 25px;
  padding: 25px 35px;
}

.contact-button:hover {
  background-color: #56abe4;
  color: white;
}

.contact-note {
  font-size: 12px;
  margin-top: 10px;
}

@media (max-width: 768px) {
  .hero-txt {
    position: relative; /* 去掉 absolute */
    top: 0px;
    width: 100%; /* 占据整个宽度 */
    padding: 16px; /* 添加内边距 */
    background: rgba(0, 0, 0, 0.9); /* 背景色保持不变 */
    color: #ffffff;
    text-align: center; /* 居中对齐 */
  }
  .hero-txt-title {
    font-size: 20px; /* 缩小字体大小以适配手机屏幕 */
    margin-bottom: 0px;
  }
  .hero-txt-desc {
    font-size: 14px;
    line-height: 1.5;
  }

  .service-txt-title {
    text-align: center;
    font-size: 30px;
    padding: 20px;
  }
  .service-txt-subtitle {
    text-align: left;
    font-size: 14px;
    padding: 14px;
  }
  .service-row {
    margin-bottom: 20px;
    padding: 0 20px;
  }
  .service-item {
    flex-direction: column;
    margin: 20px 0px;
  }

  .service-image {
    width: 100%;
    height: 250px;
    transition: transform 0.3s ease;
    border-radius: 8px;
  }
  .service-card:hover {
    transform: none;
  }
  .service-card:hover .service-image {
    transform: none;
  }
  .service-content {
    padding: 15px;
  }
  .carousel-container {
    padding: 0 20px; /* 左右添加20px余白 */
  }
  .carousel-pc {
    display: none;
  }
  .carousel-mobile {
    display: block;
    border-radius: 10px; /* 可选：为轮播图添加圆角 */
    overflow: hidden; /* 确保图片不超出边界 */
  }
  .contact-box {
    margin-bottom: 20px;
    text-align: center;
  }

  .contack-row {
    padding: 0 20px 40px 20px;
  }
  .contact-box-r {
    margin-right: 0px !important;
  }
  .contact-box-l {
    margin-left: 0px !important;
  }
}
</style>
